import { useCallback, useEffect, useState } from 'react'
import { Dashboard } from './pages/Dashboard'
import { Login } from './pages/Login'
import { ThemeProvider } from './components/theme-provider'
import { fetchDashboardSession } from './lib/api'
import './App.css'

function App() {
  const [authenticated, setAuthenticated] = useState(false)
  const [checkingSession, setCheckingSession] = useState(true)

  const loadSession = useCallback(async () => {
    setCheckingSession(true)
    try {
      const session = await fetchDashboardSession()
      setAuthenticated(Boolean(session.authenticated))
    } finally {
      setCheckingSession(false)
    }
  }, [])

  useEffect(() => {
    loadSession()
  }, [loadSession])

  return (
    <ThemeProvider defaultTheme="dark" storageKey="fluplottery-theme">
      {checkingSession ? (
        <div className="flex items-center justify-center min-h-screen">Checking session...</div>
      ) : authenticated ? (
        <Dashboard />
      ) : (
        <Login onSuccess={loadSession} />
      )}
    </ThemeProvider>
  )
}

export default App
